import * as React from "react";
import { AddCard } from "../NotifierForm/Accounts/AddCard";
import { Account } from "@/types";
import { AddedAccountCard } from "../NotifierForm/Accounts/AddedAccountCard";
import { MAS, MultiAccountUi } from "@/hooks/useMultiAccount";
import { ExpressFormMenuKey } from "./express-data";

export interface CIMultiAccountList {
  readonly accounts: ReadonlyArray<Account>;
  readonly updateMAS: React.Dispatch<React.SetStateAction<MAS>>;
  readonly updateTemplate: any;
  readonly goToNextSection: any;
  readonly multiAccountRemove: any;
  readonly onSectionClick: (section: string) => void;
}
// const CURRENT_SECTION_STORAGE_KEY = ExpressStoreKey.MultiAccount;
const FORM_STEP_CURRENT_SECTION = ExpressFormMenuKey.Account;

export default function MultiAccountList({
  accounts,
  updateMAS,
  updateTemplate,
  goToNextSection,
  multiAccountRemove,
  onSectionClick,
}: CIMultiAccountList): React.ReactElement {
  React.useEffect(() => {
    if (accounts?.length !== 0) {
      updateTemplate((s: any) => {
        return {
          ...s,
          onNext: () => goToNextSection(),
          nextLabel: "Next Section",
          currentSection: FORM_STEP_CURRENT_SECTION,
          nestedFunc: false,
          onSectionClick,
        };
      });
    } else {
      updateTemplate((s: any) => {
        return {
          ...s,
          currentSection: FORM_STEP_CURRENT_SECTION,
          onNext: null,
          nextLabel: "Next Section",
          nestedFunc: false,
          onSectionClick,
        };
      });
    }
  }, [updateTemplate, accounts, onSectionClick, goToNextSection]);

  const onClickAdd = React.useCallback(() => {
    updateMAS((s: MAS) => ({
      ...s,
      view: MultiAccountUi.Form,
    }));
  }, [updateMAS]);

  const onClickEdit = React.useCallback(
    (id: string | undefined) => {
      updateMAS((s: MAS) => ({
        ...s,
        view: MultiAccountUi.Form,
        current: s.accounts.find(({ id: aid }: Account) => id === aid),
        accounts: s.accounts.filter(({ id: aid }: Account) => id !== aid),
      }));
    },
    [updateMAS]
  );

  return (
    <>
      <AddCard label="Add account" onClick={onClickAdd} />
      {accounts.map((account, index) => (
        <AddedAccountCard
          key={`${account.companyName}-${account.serviceProviderType}-${index}`}
          account={account}
          index={index}
          onRemove={() => multiAccountRemove(account.id)}
          onEditAccount={() => onClickEdit(account.id)}
        />
      ))}
    </>
  );
}
